import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoHeader from '../Inicio/components/LogoHeader';

function HorariosPage() {
  const navigate = useNavigate();
  const [selectedDay, setSelectedDay] = useState(null);

  const eventos = {
    "15": { titulo: "Ocupado" },
    "20": { titulo: "Ocupado" },
    "24": { titulo: "Ocupado" },
    "25": { titulo: "Ocupado" }
  };

  const dias = Array.from({ length: 31 }, (_, i) => i + 1);

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      
      {/* 1. LOGO Y NAVEGACIÓN (HEADER SUPERIOR) */}
      <div style={{ position: 'relative', zIndex: 10, backgroundColor: '#000' }}>
        <LogoHeader />
      </div>

      {/* 2. BANNER DE ANUNCIO (Estilo Bambo) */}
      <div 
        onClick={() => navigate('/login')}
        style={{ 
          backgroundColor: '#FFD700', 
          color: '#000', 
          padding: '12px', 
          textAlign: 'center', 
          fontWeight: 'bold',
          fontSize: '18px',
          cursor: 'pointer',
          borderBottom: '2px solid #333',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fff'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#FFD700'}
      >
        ⚡ Bono de Descuento de 10% por usuario nuevo ⚡
      </div>

      {/* 3. CONTENEDOR PRINCIPAL CENTRADO */}
      <div className="container" style={{ maxWidth: '1100px', margin: '0 auto', padding: '60px 20px' }}>
        
        {/* TÍTULO DEL CALENDARIO */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '32px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px' }}>
            CALENDARIO DE <span style={{ color: '#FFD700' }}>DISPONIBILIDAD</span>
          </h2>
          <p style={{ color: '#666', fontSize: '14px', marginTop: '5px', textTransform: 'uppercase' }}>Enero 2026</p>
        </div>

        {/* ESTRUCTURA DE DOS COLUMNAS (ORIGINAL) */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 350px', 
          gap: '30px', 
          alignItems: 'stretch' 
        }}>
          
          {/* LADO IZQUIERDO: EL CALENDARIO */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(7, 1fr)', 
            border: '2px solid #333',
            backgroundColor: '#111',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
          }}>
            {/* Cabeceras de días */}
            {['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'].map(d => (
              <div key={d} style={{ 
                backgroundColor: '#222', 
                color: '#FFD700', 
                padding: '15px 5px', 
                textAlign: 'center', 
                border: '1px solid #333', 
                fontWeight: '800',
                fontSize: '12px',
                textTransform: 'uppercase'
              }}>{d}</div>
            ))}

            {/* Días del mes */}
            {dias.map(dia => {
              const info = eventos[dia];
              const isSelected = selectedDay?.dia === dia;
              return (
                <div 
                  key={dia}
                  onClick={() => setSelectedDay({ dia, ...info })}
                  style={{ 
                    height: '110px', 
                    backgroundColor: isSelected ? '#333' : '#111', 
                    border: '1px solid #222',
                    cursor: 'pointer',
                    padding: '10px',
                    transition: 'all 0.2s ease',
                    position: 'relative'
                  }}
                  onMouseOver={(e) => !isSelected && (e.currentTarget.style.backgroundColor = '#1a1a1a')}
                  onMouseOut={(e) => !isSelected && (e.currentTarget.style.backgroundColor = '#111')}
                >
                  <span style={{ 
                    fontWeight: 'bold', 
                    fontSize: '18px', 
                    color: isSelected ? '#FFD700' : '#fff' 
                  }}>{dia}</span>
                  
                  {info && (
                    <div style={{ 
                      fontSize: '9px', 
                      backgroundColor: '#CC0000', 
                      color: 'white', 
                      marginTop: '15px', 
                      padding: '4px',
                      textAlign: 'center',
                      fontWeight: '900',
                      borderRadius: '2px',
                      textTransform: 'uppercase'
                    }}>OCUPADO</div>
                  )}
                </div>
              );
            })}
          </div>

          {/* LADO DERECHO: DETALLES DEL DÍA (ESTILO ORIGINAL) */}
          <div style={{ 
            border: '2px solid #333', 
            padding: '30px', 
            backgroundColor: '#111', 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
          }}>
            <h3 style={{ borderBottom: '2px solid #FFD700', paddingBottom: '15px', fontSize: '18px', fontWeight: '800', textTransform: 'uppercase' }}>
              Detalles del Día
            </h3>
            
            {selectedDay ? (
              <div style={{ marginTop: '20px' }}>
                <p style={{ fontSize: '42px', fontWeight: '900', margin: '10px 0' }}>Día {selectedDay.dia}</p>
                <p style={{ color: '#888', marginBottom: '30px', fontSize: '15px' }}>
                  {selectedDay.titulo ? "Este día ya se encuentra reservado." : "Día disponible para reserva"}
                </p>
                {!selectedDay.titulo && (
                  <button style={{ 
                    width: '100%', 
                    padding: '15px', 
                    backgroundColor: '#1a5fb4', // Azul original solicitado
                    color: 'white', 
                    border: 'none', 
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    transition: '0.3s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1e70d6'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#1a5fb4'}
                  >RESERVAR AHORA</button>
                )}
              </div>
            ) : (
              <p style={{ color: '#444', fontStyle: 'italic', marginTop: '30px' }}>Selecciona una fecha en el calendario.</p>
            )}
          </div>
        </div>

        {/* BOTÓN VOLVER (ESTILO ROJO ORIGINAL) */}
        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <button 
            onClick={() => navigate('/')}
            style={{ 
              backgroundColor: '#CC0000', 
              color: 'white', 
              padding: '16px 60px', 
              border: 'none', 
              fontWeight: 'bold', 
              cursor: 'pointer',
              fontSize: '14px',
              borderRadius: '4px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: '0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.shadow = '0 5px 15px rgba(204,0,0,0.4)'}
          >
            Volver al Inicio
          </button>
        </div>
      </div>
    </div>
  );
}

export default HorariosPage;